import {UserTracker} from "../index.js";

const eventDics = {
    "schd-all": "main:schd-all:click", // 일정 - 전체
    "schd-my": "main:schd-my:click", // 일정 - 내 일정
    "schd-register": "main:schd-register:click", // 일정 - 등록한 일정
    "schd-none": "main:schd-none:click", // 일정 - 선택안함
    "task-all": "main:task-all:click", // 업무 - 전체
    "task-my": "main:task-my:click", // 업무 - 내 업무
    "task-request": "main:task-request:click", // 업무 - 요청한 업무
    "task-none": "main:task-none:click", // 업무 - 선택안함
}

export const ScheduleFilterTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (type, gubun) => {
        let eventName = "";
        if (type === "schd") {
            switch (gubun) {
                case "0,1": eventName = "schd-all"; break;
                case "1": eventName = "schd-my"; break;
                case "0": eventName = "schd-register"; break;
                case "-1": eventName = "schd-none"; break;
            }
        } else if (type === "task") {
            switch (gubun) {
                case "2": eventName = "task-all"; break;
                case "0": eventName = "task-my"; break;
                case "1": eventName = "task-request"; break;
                case "-1": eventName = "task-none"; break;
            }
        } else {
            return;
        }
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: null, data: {}});
    }

    return Tracker;
}